import React, { useState, useEffect } from 'react';
import Sidebar from './Sidebar';
import './Members.css';

const Members = ({ isVisible, onBack, onLogout, onNavClick }) => {
  const [members, setMembers] = useState([
    { id: 2, name: 'Albert Flores', email: 'albert.flores@gmail.com', avatar: 'https://i.pravatar.cc/150?img=11', role: 'Member' },
    { id: 3, name: 'Annette Black', email: 'annette.black@gmail.com', avatar: 'https://i.pravatar.cc/150?img=5', role: 'Member' },
  ]);

  const [showAddModal, setShowAddModal] = useState(false);
  const [newMember, setNewMember] = useState({ name: '', email: '' });
  const [currentUser, setCurrentUser] = useState(null);

  // Load current user info from localStorage
  useEffect(() => {
    const loadCurrentUser = () => {
      const user = localStorage.getItem('user');
      if (user) {
        try {
          const userData = JSON.parse(user);
          // Tạo avatar từ tên hoặc email nếu không có
          const avatarUrl = userData.avatar || `https://ui-avatars.com/api/?name=${encodeURIComponent(userData.name || userData.email)}&background=667eea&color=fff&size=150`;
          
          setCurrentUser({
            id: 1,
            name: userData.name || 'User',
            email: userData.email || '',
            avatar: avatarUrl,
            role: 'Owner'
          });
        } catch (e) {
          console.error('Error parsing user data:', e);
        }
      }
    };

    loadCurrentUser();

    // Listen for profile updates
    window.addEventListener('userProfileUpdated', loadCurrentUser);
    window.addEventListener('storage', (e) => {
      if (e.key === 'user') {
        loadCurrentUser();
      }
    });

    return () => {
      window.removeEventListener('userProfileUpdated', loadCurrentUser);
    };
  }, []);

  if (!isVisible) return null;

  const handleDeleteMember = (memberId) => {
    if (window.confirm('Are you sure you want to remove this member?')) {
      setMembers(members.filter(m => m.id !== memberId));
    }
  };

  const handleAddMember = () => {
    if (newMember.name && newMember.email) {
      const newId = Math.max(...members.map(m => m.id)) + 1;
      setMembers([...members, {
        id: newId,
        name: newMember.name,
        email: newMember.email,
        avatar: `https://i.pravatar.cc/150?img=${newId}`,
        role: 'Member'
      }]);
      setNewMember({ name: '', email: '' });
      setShowAddModal(false);
    }
  };

  return (
    <div className="dashboard-container">
      <Sidebar activeId="members" onLogout={onLogout} onNavClick={onNavClick} />

      <div className="main-content members-content">
        {/* Header */}
        <div className="members-header">
          <div className="members-header-left">
            <button className="members-back-btn" onClick={onBack}>
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <line x1="19" y1="12" x2="5" y2="12"></line>
                <polyline points="12 19 5 12 12 5"></polyline>
              </svg>
            </button>
            <h1 className="members-title">Members</h1>
          </div>
          <button className="members-add-btn" onClick={() => setShowAddModal(true)}>
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <line x1="12" y1="5" x2="12" y2="19"></line>
              <line x1="5" y1="12" x2="19" y2="12"></line>
            </svg>
            Add Member
          </button>
        </div>

        {/* Members List */}
        <div className="members-list-section">
          <div className="members-list-header">
            <h2 className="members-list-title">Your Members</h2>
            <span className="members-badge">{members.length + (currentUser ? 1 : 0)}</span>
          </div>

          <div className="members-grid">
            {/* Hiển thị Owner (current user) đầu tiên nếu có */}
            {currentUser && (
              <div key={currentUser.id} className="member-card">
                <div className="member-card-header">
                  <div className="member-avatar-wrapper">
                    <img src={currentUser.avatar} alt={currentUser.name} className="member-avatar" />
                    <div className="member-owner-badge">Owner</div>
                  </div>
                  <button 
                    className="member-delete-btn"
                    disabled={true}
                    title="Cannot remove owner"
                    style={{ opacity: 0.5, cursor: 'not-allowed' }}
                  >
                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                      <polyline points="3 6 5 6 21 6"></polyline>
                      <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path>
                    </svg>
                  </button>
                </div>
                <div className="member-info">
                  <h3 className="member-name">{currentUser.name}</h3>
                  <p className="member-email">{currentUser.email}</p>
                  <span className="member-role">{currentUser.role}</span>
                </div>
              </div>
            )}
            
            {/* Hiển thị các members khác */}
            {members.map((member) => (
              <div key={member.id} className="member-card">
                <div className="member-card-header">
                  <div className="member-avatar-wrapper">
                    <img src={member.avatar} alt={member.name} className="member-avatar" />
                  </div>
                  <button 
                    className="member-delete-btn"
                    onClick={() => handleDeleteMember(member.id)}
                    title="Remove member"
                  >
                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                      <polyline points="3 6 5 6 21 6"></polyline>
                      <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path>
                    </svg>
                  </button>
                </div>
                <div className="member-info">
                  <h3 className="member-name">{member.name}</h3>
                  <p className="member-email">{member.email}</p>
                  <span className="member-role">{member.role}</span>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Add Member Modal */}
        {showAddModal && (
          <div className="members-modal-overlay" onClick={() => setShowAddModal(false)}>
            <div className="members-modal" onClick={(e) => e.stopPropagation()}>
              <div className="members-modal-header">
                <h3>Add New Member</h3>
                <button className="members-modal-close" onClick={() => setShowAddModal(false)}>
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <line x1="18" y1="6" x2="6" y2="18"></line>
                    <line x1="6" y1="6" x2="18" y2="18"></line>
                  </svg>
                </button>
              </div>
              <div className="members-modal-body">
                <div className="members-form-group">
                  <label className="members-form-label">Full Name</label>
                  <input
                    type="text"
                    className="members-form-input"
                    placeholder="Enter full name"
                    value={newMember.name}
                    onChange={(e) => setNewMember({ ...newMember, name: e.target.value })}
                  />
                </div>
                <div className="members-form-group">
                  <label className="members-form-label">Email</label>
                  <input
                    type="email"
                    className="members-form-input"
                    placeholder="Enter email address"
                    value={newMember.email}
                    onChange={(e) => setNewMember({ ...newMember, email: e.target.value })}
                  />
                </div>
              </div>
              <div className="members-modal-footer">
                <button className="members-modal-cancel" onClick={() => setShowAddModal(false)}>
                  Cancel
                </button>
                <button className="members-modal-submit" onClick={handleAddMember}>
                  Add Member
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default Members;


